interface IVCmConsole {
    info: (textArray: Array<string>) => void;
    warning: (textArray: Array<string>) => void;
    error: (textArray: Array<string>) => void;
    clear: () => void;
}

const write = (text: string) => {
    $("#cmConsole").append(text);
}

const buildText = (text: string, className: string) => {
    let date = new Date();
    let dateStr = date.format("yyyy/MM/dd HH:mm:ss");

    return `<p class="${className}">${dateStr}&nbsp;&nbsp;&nbsp;&nbsp;${text}</p>`;
}

const vConsole: IVCmConsole = {
    info: (textArray: Array<string>) => {
        let text = buildText(textArray.join(", "), "bg-light text-dark");
        write(text);
    },
    warning: (textArray: Array<string>) => {
        let text = buildText(textArray.join(", "), "bg-warning text-white");
        write(text);
    },
    error: (textArray: Array<string>) => {
        let text = buildText(textArray.join(", "), "bg-danger text-white");
        write(text);
    },
    clear: () => {
        $("#cmConsole").html("");
    }
};

(<any>window).pInfo = (...parameters: any[]) => {
    vConsole.info(Array.prototype.slice.call(parameters, 0));
};

(<any>window).pWarn = (...parameters: any[]) => {
    vConsole.warning(Array.prototype.slice.call(parameters, 0));
};

(<any>window).pWarning = (<any>window).pWarn;

export default vConsole;